export default function anonymous(it
) {
var out='<section class="related-news-flow"> <div class="related-news-flow__container" id="related-news-flow-container"></div></section>';return out;
}